
import Vue from 'vue'
import LinkButtonWrapper from '@/components/LinkButtonWrapper.vue'
import ScidIcon from '@/components/svgs/ScidIcon.vue'

export default Vue.extend({
  name: 'ScidButton',
  components: {
    LinkButtonWrapper,
    ScidIcon,
  },
  props: {
    label: {
      type: String,
      default: 'Log in with Supercell',
    },
    href: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '_blank',
    },
    to: {
      type: String,
      default: '',
    },
    adaptiveWidth: {
      type: Boolean,
      default: false,
    },
  },
})
